import { useContext, useEffect, useState } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import {
  StyleSheet,
  View,
  Text,
  ImageBackground,
  ScrollView,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";

//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "../components/VectorIcons";
//import { TextInput } from "react-native-gesture-handler";

//import LoginSVG from "../assets/images/misc/login.svg";
import CustomButton from "../components/CustomButton";
import InputField from "../components/InputField";
import { AuthContext } from "../context/AuthContext";
import PasswordCheck from "../components/PasswordCheck";
import { checkPassword } from "../context/helper";
import { pageTitle, getSchemeStyle } from "../context/helper";

const ChangePasswordScreen = ({ navigation, route }) => {
  const schemeStyles = getSchemeStyle();

  const { changePassword, logout } = useContext(AuthContext);
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass2, setNewPass2] = useState("");
  const [resultText, setResultText] = useState("");

  const showBack =
    route && route.params && route.params.showBack
      ? route.params.showBack
      : false;
  const showOldPW = false;

  const pwCheck = (oldPW, newPW1, newPW2) => {
    return (
      (!showOldPW || oldPW.length > 0) &&
      checkPassword(newPW1) > 1 &&
      newPW1 == newPW2
    );
  };

  return (
    /*         <View style={styles.imageContainer}>
          <LoginSVG
            height={300}
            width={300}
            style={{ transform: [{ rotate: "-5deg" }] }}
          />
        </View>
 */
    <SafeAreaView style={[styles.mainArea,schemeStyles.Background]}>
      <View style={styles.imageContainer}>
        <ImageBackground
          source={require("../assets/images/sencono-logo-256.png")}
          style={styles.mainImage}
        />
      </View>

      <ScrollView style={styles.mainContainer}>
        <View>
          <Text style={[styles.titleText,schemeStyles.grayText]}>Kennwort ändern</Text>
          {!showBack && (
            <Text style={[styles.continueText,schemeStyles.lightGrayText]}>
              Bevor Sie fortfahren können, müssen Sie Ihr Kennwort ändern.
            </Text>
          )}
        </View>
        {showOldPW && (
          <InputField
            style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
            label={"altes Kennwort"}
            icon={
              <Ionicons name="lock-closed-outline" size={24} color={schemeStyles.grayIcon.color} />
            }
            inputType={"password"}
            value={oldPass}
            onChangeText={(text) => setOldPass(text)}
          />
        )}
        <InputField
          style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
          label={"neues Kennwort"}
          icon={
            <Ionicons name="lock-closed-outline" size={24} color={schemeStyles.grayIcon.color} />
          }
          inputType={"password"}
          value={newPass}
          onChangeText={(text) => setNewPass(text)}
        />
        <InputField
          style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
          label={"Kennwort wiederholen"}
          icon={
            <Ionicons name="lock-closed-outline" size={24} color={schemeStyles.grayIcon.color} />
          }
          inputType={"password"}
          value={newPass2}
          onChangeText={(text) => setNewPass2(text)}
        />
        <PasswordCheck style={[{ marginBottom: 10 },schemeStyles.passwordStrength,schemeStyles.defaultText]} password={newPass} />
        <View style={styles.resultContainer}>
          <Text style={schemeStyles.resultText}>{resultText}</Text>
        </View>
        <CustomButton
          style={[schemeStyles.buttonText]}
          disabled={!pwCheck(oldPass, newPass, newPass2)}
          onPress={() => {
            changePassword(oldPass, newPass)
              .then((res) => {
                //console.log(res);
                if (showBack) navigation.goBack();
              })
              .catch((res) => {
                setResultText(res.reason);
              });
          }}
        >
          Kennwort ändern
        </CustomButton>
        <CustomButton
          style={[styles.guestButton,schemeStyles.buttonText]}
          onPress={() => {
            showBack ? navigation.goBack() : logout();
          }}
        >
          {showBack ? "Zurück" : "Abmelden"}
        </CustomButton>
      </ScrollView>
    </SafeAreaView>
  );
};

const Stack = createNativeStackNavigator();
const ChangePasswordStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        component={ChangePasswordScreen}
        name="ChangePassword"
        options={{ title: pageTitle("Kennwort ändern") }}
      />
    </Stack.Navigator>
  );
};

export default ChangePasswordStack;

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
    paddingTop: 20,
  },
  mainContainer: {
    paddingHorizontal: 25,
  },
  imageContainer: {
    alignItems: "flex-end",
    flex: 1,
    marginBottom: 40,
    marginRight: 25,
  },
  spaceView: {
    flex: 1,
  },
  mainImage: {
    opacity: 0.8,
    width: 150,
    height: 150,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
    color: "#333",
    marginBottom: 30,
  },
  continueText: {
    fontFamily: "Roboto-Medium",
    fontSize: 16,
    color: "#555",
    marginBottom: 20,
  },
  inputField: {
    marginBottom: 20,
  },
  guestButton: {
    backgroundColor: "#555",
  },
  resultContainer: {
    marginBottom: 10,
  },
});
